import { UPLOAD_SOURCES, getLogger } from '@cld/upload-widget-common';
import createBoundActionCreators, { createCustomCreator, createDispatcher } from 'common/actionsBase';
import { addNotification } from 'root/actions';
import notifications, { NOTIFICATION_IDS } from 'root/data/NotificationsData';
import { selectCloudName } from 'root/selectors';
import getGettyService from '../service';
import { selectProducts, selectDownloadedAssets, selectSelectedAsset } from '../../common/getty-selectors';
import { selectAssets } from '../../common/selectors';
import { retrieveDownloads, retrieveAssets, retrieveProducts, retrieveHomePageAssets, getAccountInfo, retrieveAssetDetails } from './helpers';

const { GETTY } = UPLOAD_SOURCES;
const logger = getLogger();

export const types = {
  DO_LOGIN: 'GETTY_DO_LOGIN',
  DO_LOGOUT: 'GETTY_DO_LOGOUT',
  SET_USER_LOGIN_SUCCESS: 'GETTY_SET_USER_LOGIN_SUCCESS',
  SET_USER_LOGOUT_SUCCESS: 'GETTY_SET_USER_LOGOUT_SUCCESS',
  SET_SEARCH_PARAMS: 'GETTY_SET_SEARCH_PARAMS',
  CLEAR_SEARCH_TERM: 'GETTY_CLEAR_SEARCH_TERM',
  CLEAR_FILTER_PARAMS: 'GETTY_CLEAR_FILTER_PARAMS',
  RETRIEVE_ASSETS: 'GETTY_RETRIEVE_ASSETS',
  CLEAR_RESULTS: 'GETTY_CLEAR_RESULTS',
  SET_RESULTS_RETRIEVE_START: 'GETTY_SET_RESULTS_RETRIEVE_START',
  SET_RESULTS_RETRIEVE_END: 'GETTY_SET_RESULTS_RETRIEVE_END',
  SET_RESULTS_RETRIEVE_SUCCESS: 'GETTY_SET_RESULTS_RETRIEVE_SUCCESS',
  SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS: 'GETTY_SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS',
  TOGGLE_FILTERS_PANEL: 'GETTY_TOGGLE_FILTERS_PANEL',
  SELECT_ASSETS: 'GETTY_SELECT_ASSETS',
  SELECT_PRODUCT: 'GETTY_SELECT_PRODUCT',
  SELECT_ASSETS_FORMAT: 'GETTY_SELECT_ASSETS_FORMAT',
  PURCHASE: 'GETTY_PURCHASE',
  PURCHASE_START: 'GETTY_PURCHASE_START',
  PURCHASE_END: 'GETTY_PURCHASE_END',
  PURCHASE_SUCCESS: 'GETTY_PURCHASE_SUCCESS',
  RETRIEVE_ASSET_DETAILS: 'GETTY_RETRIEVE_ASSET_DETAILS',
  RETRIEVE_ASSET_DETAILS_SUCCESS: 'GETTY_RETRIEVE_ASSET_DETAILS_SUCCESS',
  RETRIEVE_HOME_PAGE_ASSETS: 'GETTY_RETRIEVE_HOME_PAGE_ASSETS',
  RETRIEVE_PRODUCTS: 'GETTY_RETRIEVE_PRODUCTS',
  RETRIEVE_PRODUCTS_SUCCESS: 'GETTY_RETRIEVE_PRODUCTS_SUCCESS',
  RETRIEVE_DOWNLOADS_SUCCESS: 'GETTY_RETRIEVE_DOWNLOADS_SUCCESS',
  RETRIEVE_ACCOUNT_INFO_SUCCESS: 'GETTY_RETRIEVE_ACCOUNT_INFO_SUCCESS',
};

export default createBoundActionCreators(types, {
  [types.DO_LOGIN]: createCustomCreator(async (payload, dispatch, getState) => {
    const dispatcher = createDispatcher(dispatch);
    dispatcher(types.SET_USER_LOGIN_SUCCESS);
    await getAccountInfo(dispatch, getState, dispatcher);
    logger.log('[iStock.actions]: user logged in successfull');
  }),
  [types.DO_LOGOUT]: createCustomCreator((dispatch, getState, dispatcher) => {
    const service = getGettyService();
    const state = getState();
    const cloudName = selectCloudName(state);
    service.logout(cloudName);

    dispatcher(types.SET_USER_LOGOUT_SUCCESS);
    logger.log('[iStock.actions]: user logged out successfull');
  }),
  [types.RETRIEVE_ASSETS]: createCustomCreator(async (payload, dispatch, getState, dispatcher) => {
    const state = getState();
    const { assetsInProgress } = selectAssets(state, GETTY);
    const { shouldDownloadsBeRefreshed } = selectDownloadedAssets(state, GETTY);

    if (!assetsInProgress) {
      if (shouldDownloadsBeRefreshed) {
        await retrieveDownloads(dispatch, getState, dispatcher);
      }
      await retrieveAssets(payload, dispatch, getState, dispatcher);
    }
  }),
  [types.RETRIEVE_HOME_PAGE_ASSETS]: createCustomCreator(async (dispatch, getState, dispatcher) => {
    const state = getState();
    const { assetsInProgress } = selectAssets(state, GETTY);
    const { shouldDownloadsBeRefreshed } = selectDownloadedAssets(state, GETTY);
    if (!assetsInProgress) {
      if (shouldDownloadsBeRefreshed) {
        await retrieveDownloads(dispatch, getState, dispatcher);
      }
      await retrieveHomePageAssets(dispatch, getState, dispatcher);
    }
  }),
  [types.RETRIEVE_PRODUCTS]: createCustomCreator(async (dispatch, getState, dispatcher) => {
    await retrieveProducts(dispatch, getState, dispatcher);
  }),
  [types.PURCHASE]: createCustomCreator(async (dispatch, getState, dispatcher) => {
    dispatcher(types.PURCHASE_START);
    const service = getGettyService();
    const state = getState();
    const cloudName = selectCloudName(state);
    const { selectedAsset, selectedFormat } = selectSelectedAsset(state, GETTY);
    const { selectedProduct } = selectProducts(state, GETTY);

    const result = await service.purchase(selectedAsset, selectedFormat, selectedProduct, cloudName);

    if (result?.uri) {
      dispatcher(types.PURCHASE_SUCCESS, result);
      if (!selectedAsset.isPurchased) {
        if (selectedAsset.isVideo) {
          addNotification(notifications[NOTIFICATION_IDS.VIDEO_ACQUIRED], dispatch);
        } else {
          addNotification(notifications[NOTIFICATION_IDS.IMAGE_ACQUIRED], dispatch);
        }
        await retrieveProducts(dispatch, getState, dispatcher);
      }
    } else if (result?.error) {
      addNotification(notifications[NOTIFICATION_IDS.ACQUISITION_FAILED], dispatch);
    }
    dispatcher(types.PURCHASE_END);
  }),
  [types.RETRIEVE_ASSET_DETAILS]: createCustomCreator(async (payload, dispatch, getState, dispatcher) => {
    await retrieveAssetDetails(payload, dispatch, getState, dispatcher);
  }),
});
